var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-qna-modal-component" }, [
    _c("div", { staticClass: "room-qna-wrapper" }, [
      _c("header", { staticClass: "room-qna-header" }, [
        _c("h6", [_vm._v(_vm._s(_vm.$t("qna.title")))]),
      ]),
      _c("div", { staticClass: "room-qna-content" }, [
        _c("div", { staticClass: "qna-menu" }, [
          _c(
            "button",
            {
              staticClass: "qna-menu-btn menu-btn-list",
              class: { selected: _vm.selectedTab === "list" },
              on: {
                click: function ($event) {
                  _vm.selectedTab = "list"
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("qna.list.title")))]
          ),
          _c(
            "button",
            {
              staticClass: "qna-menu-btn menu-btn-form",
              class: [
                { selected: _vm.selectedTab === "form" },
                { blocked: !_vm.isParticipantRole() },
              ],
              on: {
                click: function ($event) {
                  _vm.selectedTab = "form"
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("qna.list.btn")))]
          ),
        ]),
        _vm.selectedTab === "list"
          ? _c("div", { staticClass: "qna-list-wrapper" }, [
              _c("div", { staticClass: "qna-order-select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedOption,
                        expression: "selectedOption",
                      },
                    ],
                    staticClass: "form-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedOption = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.orderOptions, function (order, i) {
                    return _c(
                      "option",
                      { key: i, domProps: { value: order.value } },
                      [_vm._v(_vm._s(order.label))]
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "qna-list" }, [
                !_vm.questionList.length
                  ? _c("div", { staticClass: "qna-list-empty" }, [
                      _vm._v(" " + _vm._s(_vm.$t("qna.list.noQuestion")) + " "),
                    ])
                  : _c("div", { staticClass: "qna-items-wrap" }, [
                      _c(
                        "ol",
                        { staticClass: "qna-items" },
                        _vm._l(_vm.questionList, function (question, i) {
                          return _c(
                            "li",
                            { key: i, staticClass: "qna-item" },
                            [
                              _c("div", { staticClass: "qna-item-wrapper" }, [
                                _c("div", { staticClass: "qna-q" }),
                                _c("div", { staticClass: "qna-content" }, [
                                  _c("div", { staticClass: "qna-nickname" }, [
                                    _vm._v(_vm._s(question.nickname)),
                                  ]),
                                  _c("div", { staticClass: "qna-text" }, [
                                    _vm._v(_vm._s(question.content)),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "qna-comment-btn-wrapper" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "qna-like-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickLike(question)
                                            },
                                          },
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "qna-like-icon",
                                            class: {
                                              liked: !!question.likes.length,
                                            },
                                          }),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.$t("qna.like.title")) +
                                                " " +
                                                _vm._s(
                                                  question.likes.length > 0
                                                    ? _vm.$t("qna.like.count", {
                                                        0: question.likes
                                                          .length,
                                                      })
                                                    : ""
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "qna-comment-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickComment(
                                                question.questionId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getCommentBtnText(question)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c(
                                "Transition",
                                { attrs: { name: "slide-down" } },
                                [
                                  _vm.qnaCommentId === question.questionId
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "qna-comment-list-wrapper",
                                        },
                                        [
                                          _c(
                                            "ol",
                                            { staticClass: "qna-comment-list" },
                                            _vm._l(
                                              question.comments,
                                              function (comment, i) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "qna-comment-item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(comment) +
                                                        " "
                                                    ),
                                                    _c("div", {
                                                      staticClass:
                                                        "qna-comment-icon",
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "qna-content",
                                                      },
                                                      [
                                                        _c("p", {
                                                          staticClass:
                                                            "qna-nickname",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              comment.username
                                                            ),
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "qna-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                comment.text
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "qna-comment-regdate",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getRegDateForm(
                                                              comment.regDate
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.hasEmceeRole()
                                                      ? _c("div", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value:
                                                                "댓글 삭제",
                                                              expression:
                                                                "'댓글 삭제'",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "btn-qna-comment-remove",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onClickDeleteComment(
                                                                question.questionId,
                                                                comment.commentId
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "qna-comment-input-wrapper",
                                            },
                                            [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.commentText,
                                                    expression: "commentText",
                                                  },
                                                ],
                                                staticClass:
                                                  "qna-comment-input",
                                                attrs: {
                                                  placeholder:
                                                    _vm.$t("qna.placeholder"),
                                                  maxlength: "100",
                                                },
                                                domProps: {
                                                  value: _vm.commentText,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.commentText =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "qna-comment-register-btn",
                                                  class: {
                                                    active:
                                                      !!_vm.commentText.length,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onClickPostComment(
                                                        question.questionId
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "qna.register.title"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("div", { staticClass: "qna-regdate" }, [
                                _vm._v(
                                  _vm._s(_vm.getRegDateForm(question.regDate))
                                ),
                              ]),
                              _vm.hasEmceeRole()
                                ? _c("div", {
                                    staticClass: "btn-qna-item-remove",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteQnA(
                                          question.questionId
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
              ]),
            ])
          : _c("div", { staticClass: "qna-form" }, [
              _c("div", { staticClass: "qna-form-wrapper" }, [
                _c("div", { staticClass: "qna-form-header" }, [
                  _c("div", { staticClass: "qna-form-title" }, [
                    _vm._v(_vm._s(_vm.$t("qna.question.text"))),
                  ]),
                  _c("div", { staticClass: "qna-form-len-layer" }, [
                    _vm._v("("),
                    _c("span", { staticClass: "qna-form-text-len" }, [
                      _vm._v(_vm._s(_vm.questionText.length)),
                    ]),
                    _vm._v(" / 100)"),
                  ]),
                ]),
                _c("div", { staticClass: "qna-form-body" }, [
                  _c("textarea", {
                    attrs: {
                      placeholder: _vm.$t("qna.placeholder"),
                      maxlength: "100",
                    },
                    domProps: { value: _vm.questionText },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "qna-form-footer",
                    class: { active: !!_vm.questionText.length },
                    on: {
                      click: function ($event) {
                        return _vm.onClickRegister(_vm.questionText)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("qna.question.register")) + " ")]
                ),
              ]),
            ]),
      ]),
      _vm.hasEmceeRole()
        ? _c("div", { staticClass: "qna-list-btn-wrap" }, [
            _c(
              "button",
              {
                staticClass: "btn-qna-list-save",
                on: { click: _vm.saveQuestions },
              },
              [_vm._v(" " + _vm._s(_vm.$t("qna.question.download")) + " ")]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "qna-close-wrap" },
        [_c("GrmCloseBtn", { on: { click: _vm.onClose } })],
        1
      ),
      _vm.selectedTab === "list" &&
      !_vm.hasEmceeRole() &&
      _vm.roomSetting["useQnAShare"]
        ? _c("label", { staticClass: "chk-my-qna" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showOnlyOwnQuestion,
                  expression: "showOnlyOwnQuestion",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showOnlyOwnQuestion)
                  ? _vm._i(_vm.showOnlyOwnQuestion, null) > -1
                  : _vm.showOnlyOwnQuestion,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.showOnlyOwnQuestion,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showOnlyOwnQuestion = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showOnlyOwnQuestion = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showOnlyOwnQuestion = $$c
                  }
                },
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("qna.question.onlyMine")))]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }